// Enrollment
export const LOYALTY_ENROLL_REQUEST = "LOYALTY_ENROLL_REQUEST";
export const LOYALTY_ENROLL_SUCCESS = "LOYALTY_ENROLL_SUCCESS";
export const LOYALTY_ENROLL_ERROR = "LOYALTY_ENROLL_ERROR";

// Customer Lookup (check if already enrolled)
export const LOYALTY_LOOKUP_REQUEST = "LOYALTY_LOOKUP_REQUEST";
export const LOYALTY_LOOKUP_SUCCESS = "LOYALTY_LOOKUP_SUCCESS";
export const LOYALTY_LOOKUP_ERROR = "LOYALTY_LOOKUP_ERROR";
export const LOYALTY_LOOKUP_CLEAR = "LOYALTY_LOOKUP_CLEAR";

// Customer Dashboard (points, tier, rewards, transactions)
export const LOYALTY_DASHBOARD_REQUEST = "LOYALTY_DASHBOARD_REQUEST";
export const LOYALTY_DASHBOARD_SUCCESS = "LOYALTY_DASHBOARD_SUCCESS";
export const LOYALTY_DASHBOARD_ERROR = "LOYALTY_DASHBOARD_ERROR";

// Program Exists by Location (check if brand has program + location enrolled)
export const LOYALTY_PROGRAM_EXISTS_REQUEST = "LOYALTY_PROGRAM_EXISTS_REQUEST";
export const LOYALTY_PROGRAM_EXISTS_SUCCESS = "LOYALTY_PROGRAM_EXISTS_SUCCESS";
export const LOYALTY_PROGRAM_EXISTS_ERROR = "LOYALTY_PROGRAM_EXISTS_ERROR";

// Available Rewards
export const LOYALTY_AVAILABLE_REWARDS_REQUEST = "LOYALTY_AVAILABLE_REWARDS_REQUEST";
export const LOYALTY_AVAILABLE_REWARDS_SUCCESS = "LOYALTY_AVAILABLE_REWARDS_SUCCESS";
export const LOYALTY_AVAILABLE_REWARDS_ERROR = "LOYALTY_AVAILABLE_REWARDS_ERROR";

// Apply Reward to Order
export const LOYALTY_APPLY_REWARD_REQUEST = "LOYALTY_APPLY_REWARD_REQUEST";
export const LOYALTY_APPLY_REWARD_SUCCESS = "LOYALTY_APPLY_REWARD_SUCCESS";
export const LOYALTY_APPLY_REWARD_ERROR = "LOYALTY_APPLY_REWARD_ERROR";
// Stores the full list of applied redemptions (single or bulk) so the rewards panel can rebuild
// its "Remove" button mapping after re-opening.
export const LOYALTY_SET_APPLIED_REDEMPTIONS = "LOYALTY_SET_APPLIED_REDEMPTIONS";

// Remove Reward from Order
export const LOYALTY_REMOVE_REWARD_REQUEST = "LOYALTY_REMOVE_REWARD_REQUEST";
export const LOYALTY_REMOVE_REWARD_SUCCESS = "LOYALTY_REMOVE_REWARD_SUCCESS";
export const LOYALTY_REMOVE_REWARD_ERROR = "LOYALTY_REMOVE_REWARD_ERROR";

// Points Preview
export const LOYALTY_POINTS_PREVIEW_REQUEST = "LOYALTY_POINTS_PREVIEW_REQUEST";
export const LOYALTY_POINTS_PREVIEW_SUCCESS = "LOYALTY_POINTS_PREVIEW_SUCCESS";
export const LOYALTY_POINTS_PREVIEW_ERROR = "LOYALTY_POINTS_PREVIEW_ERROR";

// Order Identify (link customer to order)
export const LOYALTY_ORDER_IDENTIFY_REQUEST = "LOYALTY_ORDER_IDENTIFY_REQUEST";
export const LOYALTY_ORDER_IDENTIFY_SUCCESS = "LOYALTY_ORDER_IDENTIFY_SUCCESS";
export const LOYALTY_ORDER_IDENTIFY_ERROR = "LOYALTY_ORDER_IDENTIFY_ERROR";

// Checkout Summary
export const LOYALTY_CHECKOUT_SUMMARY_REQUEST = "LOYALTY_CHECKOUT_SUMMARY_REQUEST";
export const LOYALTY_CHECKOUT_SUMMARY_SUCCESS = "LOYALTY_CHECKOUT_SUMMARY_SUCCESS";
export const LOYALTY_CHECKOUT_SUMMARY_ERROR = "LOYALTY_CHECKOUT_SUMMARY_ERROR";

// Order Complete (finalize rewards + accrue points)
export const LOYALTY_ORDER_COMPLETE_REQUEST = "LOYALTY_ORDER_COMPLETE_REQUEST";
export const LOYALTY_ORDER_COMPLETE_SUCCESS = "LOYALTY_ORDER_COMPLETE_SUCCESS";
export const LOYALTY_ORDER_COMPLETE_ERROR = "LOYALTY_ORDER_COMPLETE_ERROR";

// Accrue Points (POST /loyalty/points/accrue) — fired after successful payment
export const LOYALTY_ACCRUE_POINTS_REQUEST = "LOYALTY_ACCRUE_POINTS_REQUEST";
export const LOYALTY_ACCRUE_POINTS_SUCCESS = "LOYALTY_ACCRUE_POINTS_SUCCESS";
export const LOYALTY_ACCRUE_POINTS_ERROR = "LOYALTY_ACCRUE_POINTS_ERROR";
// Signals that the post-payment accrue is in-flight (dispatched before the API call in cartSaga).
export const LOYALTY_ACCRUE_IN_FLIGHT = "LOYALTY_ACCRUE_IN_FLIGHT";

// Active Promotions at Location
export const LOYALTY_ACTIVE_PROMOS_SUCCESS = "LOYALTY_ACTIVE_PROMOS_SUCCESS";
export const LOYALTY_ACTIVE_PROMOS_ERROR = "LOYALTY_ACTIVE_PROMOS_ERROR";

// Receipt Data
export const LOYALTY_RECEIPT_DATA_REQUEST = "LOYALTY_RECEIPT_DATA_REQUEST";
export const LOYALTY_RECEIPT_DATA_SUCCESS = "LOYALTY_RECEIPT_DATA_SUCCESS";
export const LOYALTY_RECEIPT_DATA_ERROR = "LOYALTY_RECEIPT_DATA_ERROR";

// Wallet Pass
export const LOYALTY_WALLET_PASS_GENERATE_REQUEST = "LOYALTY_WALLET_PASS_GENERATE_REQUEST";
export const LOYALTY_WALLET_PASS_GENERATE_SUCCESS = "LOYALTY_WALLET_PASS_GENERATE_SUCCESS";
export const LOYALTY_WALLET_PASS_GENERATE_ERROR = "LOYALTY_WALLET_PASS_GENERATE_ERROR";

export const LOYALTY_WALLET_PASS_GET_REQUEST = "LOYALTY_WALLET_PASS_GET_REQUEST";
export const LOYALTY_WALLET_PASS_GET_SUCCESS = "LOYALTY_WALLET_PASS_GET_SUCCESS";
export const LOYALTY_WALLET_PASS_GET_ERROR = "LOYALTY_WALLET_PASS_GET_ERROR";

// Reset
export const LOYALTY_RESET = "LOYALTY_RESET";
// Invalidate cached data so next page entry re-fetches fresh data
export const LOYALTY_INVALIDATE_CACHE = "LOYALTY_INVALIDATE_CACHE";

// Pay-at-Store / Pay-on-Delivery suppression flag — when true, the next order created
// must NOT trigger the apply-reward (redeem) or accrue-points APIs.
export const LOYALTY_SET_SKIP_FOR_ORDER = "LOYALTY_SET_SKIP_FOR_ORDER";

// Customer Transactions (full history)
export const LOYALTY_CUSTOMER_TRANSACTIONS_REQUEST = "LOYALTY_CUSTOMER_TRANSACTIONS_REQUEST";
export const LOYALTY_CUSTOMER_TRANSACTIONS_SUCCESS = "LOYALTY_CUSTOMER_TRANSACTIONS_SUCCESS";
export const LOYALTY_CUSTOMER_TRANSACTIONS_ERROR = "LOYALTY_CUSTOMER_TRANSACTIONS_ERROR";

// Points to redeem — capped to order total for value_per_points rewards
export const LOYALTY_SET_POINTS_TO_REDEEM = "LOYALTY_SET_POINTS_TO_REDEEM";
